<template>
  <div
    class="emd-card-content emd-container__content"
    :class="customClass"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EmdCardContent',
  props: {
    customClass: {
      type: String,
      default: 'eu-pa_4'
    }
  }
}
</script>

<style scoped>
.emd-card-content {
  height: calc(100% - 53px); /* 53px header */
}
</style>
